import { Outlet } from "react-router-dom";

const AdminWrapper: React.FC = () => {
    return <Outlet />;
};

export default AdminWrapper;